import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { notificationSettingsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UpdateNotificationsSettingsMutationProps = {
	userId: string;
	notificationSettingsId: string;
	refetchNotificationSettings: Function;
};

const useUpdateNotificationsSettingsMutation = ({
	userId,
	notificationSettingsId,
	refetchNotificationSettings,
}: UpdateNotificationsSettingsMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		(fieldId: string) => {
			return notificationSettingsService.updateNotificationSettings({
				userId,
				notificationSettingsId,
				fieldId,
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				refetchNotificationSettings?.();
			},
		},
	);
};

export default useUpdateNotificationsSettingsMutation;
